import { render, staticRenderFns } from "./BadgeManage.vue?vue&type=template&id=eb3f5c74"
import script from "./BadgeManage.vue?vue&type=script&lang=js"
export * from "./BadgeManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports